<template lang="pug">
  div(v-cloak)
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {}
  },
  created () {
    let redirectRoute = this.reloadRoute
    redirectRoute && this.$router.replace(redirectRoute)
  },
  watch: {
    isAuthenticated () {
      let redirectRoute = this.reloadRoute
      redirectRoute && this.$router.replace(redirectRoute)
    }
  },
  computed: {
    ...mapGetters('common/account', ['isAuthenticated']),
    reloadRoute () {
      if (!this.isAuthenticated) {
        return {path: '/request'}
      }
      return {
        path: '/dashboard',
        name: 'dashboard',
        redirect: '/dashboard'
      }
    }
  }
}
</script>

<style scoped lang="stylus">
</style>



// WEBPACK FOOTER //
// src/app/pages/AppDispatch/index.vue